import React, { useEffect } from "react";
import "../../css/ac/HomeProductions.css";
import "../../css/home/banner.css";

function ProductCard({ title, description, imgSrc, imgPosition = "left" }) {
    // Animasyon sınıflarını belirle
    const titleAnimClass = imgPosition === "left" ? "animate-from-right" : "animate-from-left";
    const paragraphAnimClass = "animate-from-bottom";

    return (
        <div className="Row">
            <div className="content-wrapper">
                {imgPosition === "left" && (
                    <div className="half image-container">
                        <img className="images" src={imgSrc} alt="Station" />
                    </div>
                )}
                <div className="half">
                    <div className="Column">
                        {/* Başlangıçta sadece hidden, hangi animasyon verileceğini data-anim ile belirt */}
                        <h1 className="HomeProductionsText hidden" data-anim={titleAnimClass}>{title}</h1>
                        <p className="homePage hidden" data-anim={paragraphAnimClass}>{description}</p>
                    </div>
                </div>
                {imgPosition === "right" && (
                    <div className="half image-container">
                        <img className="images" src={imgSrc} alt="Station" />
                    </div>
                )}
            </div>
        </div>
    );
}

function MobileAppinstruction() {
    const Usage = "Uygulamayı www.dapsarj.com web sitesi üzerinden yada Play Store ve App Store uygulamalarından indirerek kullanmaya başlayabilirsiniz. Uygulamayı yükledikten sonra telefon numaranız ve e-posta adresinizle kolayca kayıt olabilirsiniz. İstasyonlarınızı QR kod veya barkod numaralarıyla, www.dapsarj.com/help adresindeki yönergeleri takip ederek kolayca hesabınıza ekleyip kullanmaya başlayabilirsiniz. Dilerseniz şarj istasyonunuzu web sitemiz üzerinden de kullanabilirsiniz.";
    const Header = "Mobil Uygulama Kullanımı";
    const InformationHeader = "Mobil Uygulamanın Avantajları";
    const Content = "Dapsarj Smart, Premium ve Dual modelleriyle şarj istasyonunuzu mobil uygulama veya web sitesi üzerinden kullanabilirsiniz. İster istasyonun yakınında olun ister uzakta, şarj işlemini uzaktan başlatıp durdurabilir, saat aralıklarına göre şarj programlayabilir ve şarj durumunuzu istediğiniz zaman görüntüleyebilirsiniz. Ayrıca kâr oranınızı anlık, aylık ve yıllık olarak inceleyebilirsiniz.";

    useEffect(() => {
        const hiddenElements = document.querySelectorAll('.hidden');
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const animClass = entry.target.getAttribute('data-anim');

                if (entry.isIntersecting) {
                    // Eleman görünür alana girdi
                    entry.target.classList.remove('hidden');
                    if (animClass) {
                        entry.target.classList.add(animClass);
                    }
                } else {
                    // Eleman görünür alandan çıktı
                    // Tekrar animasyon yapmak için tekrar .hidden ekleyip animClass'ı kaldır.
                    entry.target.classList.add('hidden');
                    if (animClass) {
                        entry.target.classList.remove(animClass);
                    }
                }
            });
        }, {
            threshold: 0.1
        });

        hiddenElements.forEach(el => observer.observe(el));

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <div>
            <ProductCard
                title={InformationHeader}
                description={Content}
                imgSrc="/assets/home/stations/app.png"
                imgPosition="right"
            />
            <ProductCard
                title={Header}
                description={Usage}
                imgSrc="/assets/home/MAI/first.png"
                imgPosition="left"
            />
        </div>
    );
}

export default MobileAppinstruction;
